import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "TrackReadReceipts" */ "./lazyIndex"), { name: "TrackReadReceipts" });

export const lazyShowReadReceiptsDialog: LazyAction<typeof lazyIndex.showReadReceiptsDialog, typeof lazyModule> = new LazyAction(lazyModule, m => m.showReadReceiptsDialog);
